var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-bottom-sheet',{attrs:{"inset":"","max-width":"600px","scrollable":""},model:{value:(_vm.editStore.editSubtitles),callback:function ($$v) {_vm.$set(_vm.editStore, "editSubtitles", $$v)},expression:"editStore.editSubtitles"}},[_c('SubtitlesEditCard')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }